export default __webpack_public_path__ + "static/media/IMG_1307.344a3148.jpg";